<div class="upload-questionnaire-wrapper">
  <div class="upload-questionnaire-container">
    <div class="questionnaire-content-header">
      <div class="questionnaire-title">
        {{ questionnaireContent.uploadTitle }}
      </div>
      <div class="questionnaire-sub-title">
        {{ questionnaireContent.uploadSubTitle }}
      </div>
    </div>
    <div class="file-upload">
      <ng-container *ngIf="!file; else fileUploaded">
        <u-file-upload
          [dragAndDropFile]="true"
          [mode]="'advanced'"
          [accept]="acceptTypes"
          [maxFileSize]="MAX_FILE_SIZE"
          [hideRemoveIcon]="true"
          [showThemeName]="false"
          [previewSize]="FILE_UPLOAD_SIZE"
          [uploadOnHoverText]="questionnaireContent.uploadOnHoverText"
          [dragAndDropText]="questionnaireContent.dragAndDropText"
          [uploadText]="questionnaireContent.uploadText"
          [definitionOfAcceptType]="questionnaireContent.definitionOfAcceptType"
          [errorFileTypeMsg]="questionnaireContent.errorFileTypeMsg"
          [displayUploadIcon]="true"
          (onSelect)="onUpload($event)"
          class="upload-image-button"
        ></u-file-upload>
      </ng-container>
      <ng-template #fileUploaded>
        <div class="file-uploaded" [ngClass]="{ 'loading-file': loadingFile, 'error-file': uploadFailed || incorrectContent }">
          <div class="details-file">
            <u-icon [model]="{ type: 'font', value: 'icon-page' }" class="file-icon"></u-icon>
            <span class="file-name">
              {{ questionnaireContent.requestForProposal }} <span class="name">{{ data.fileName }} </span>.{{ data.extension }}
            </span>
          </div>
          <div *ngIf="loadingFile; else deleteFile" class="delete-file">
            <div class="cancel-file" (click)="onDeleteFile(true)">Cancel</div>
            <i class="pi pi-spin pi-spinner" [ngStyle]="{ 'font-size': '14px', color: 'var(--color-text-secondary)' }"></i>
          </div>
          <ng-template #deleteFile>
            <div class="delete-file">
              <u-button type="secondary" onlyIcon="true" fontIcon="delete" (onClick)="onDeleteFile()"></u-button>
            </div>
          </ng-template>
        </div>
      </ng-template>
      <span class="upload-failed" *ngIf="uploadFailed">{{ questionnaireContent.errorUploadMsg }}</span>
      <span class="upload-failed" *ngIf="incorrectContent">{{ questionnaireContent.errorIncorrectContent }}</span>
    </div>
    <div class="select-assistant">
      <div class="auto-complete-container">
        <u-icon class="icon-assistant"></u-icon>
        <u-auto-complete
          field="name"
          [placeholder]="SELECTED_PLACE_HOLDER"
          [suggestionItems]="assistantsList"
          (onChange)="onSelectItem($event)"
          [expandOnInputClick]="true"
          [width]="'441px'"
          [viewMode]="'tag'"
          [removeSelected]="false"
          [selectedItems]="selectedAssistant ? [selectedAssistant] : null"
          [ngClass]="{ selected: !!selectedAssistant }"
          [displayCreateNew]="true"
          [createNewOption]="true"
          [showArrow]="true"
        >
          <ng-template let-item pTemplate="item">
            <div *ngIf="!item.isNew" class="auto-complete-select-item" [ngClass]="{ 'item-disable': item?.disable }">
              <span class="title">{{ item.name }}</span>
              <avatar-list class="avatar-list" [model]="item.avatarList" [spreadAvatarsCount]="3" [tooltipLimit]="10"></avatar-list>
            </div>
          </ng-template>
        </u-auto-complete>
      </div>
      <span class="description">
        {{ OPTIONAL_ASSISTANT }}
      </span>
    </div>
  </div>
  <u-button
    class="continue-button"
    [disabled]="disabledButton"
    [label]="'Continue'"
    [styles]="{ width: '180px' }"
    type="primary"
    (mousedown)="continue()"
  ></u-button>
</div>
